import { SpaceType } from '../types/swagger'

export default (str: string): str is SpaceType => [
    'map', 'presentation', 'booth', 'networking', 'cinema', 'jobs', 'meeting', 'posters', 'chat_roulette', 'embedded'
].includes(str)
